import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 36467 25414"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M13049 24953 632 14099c-843-737-843-2047 0-2784L13049 461c1196-1045 3065-196 3065 1391v21710c0 1587-1869 2436-3065 1391z"
        className="fil0"
      />
      <g id="_1970276450288">
        <path
          d="M20715 4028c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306-722 0-1306-585-1306-1306s584-1306 1306-1306zM20715 8943c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306-722 0-1306-584-1306-1306 0-721 584-1306 1306-1306z"
          className="fil0"
        />
        <circle cx={20715} cy={15164} r={1306} className="fil0" />
        <path
          d="M20715 18773c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306-722 0-1306-584-1306-1306 0-721 584-1306 1306-1306z"
          className="fil0"
        />
      </g>
      <g id="_1970276451216">
        <path
          d="M25530 4028c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306s-1306-585-1306-1306 585-1306 1306-1306zM25530 8943c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306s-1306-584-1306-1306c0-721 585-1306 1306-1306zM25530 13858c721 0 1306 584 1306 1306 0 721-585 1306-1306 1306s-1306-584-1306-1306c0-721 585-1306 1306-1306zM25530 18773c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306s-1306-584-1306-1306c0-721 585-1306 1306-1306z"
          className="fil0"
        />
      </g>
      <g id="_1970276453424">
        <path
          d="M30345 8943c722 0 1306 585 1306 1306 0 722-584 1306-1306 1306-721 0-1306-584-1306-1306 0-721 585-1306 1306-1306zM30345 13858c722 0 1306 584 1306 1306 0 721-584 1306-1306 1306-721 0-1306-584-1306-1306 0-721 585-1306 1306-1306z"
          className="fil0"
        />
      </g>
      <g id="_1970276452432">
        <path
          d="M35161 8943c721 0 1306 585 1306 1306 0 722-585 1306-1306 1306-722 0-1306-584-1306-1306 0-721 584-1306 1306-1306z"
          className="fil0"
        />
        <circle cx={35161} cy={15164} r={1306} className="fil0" />
      </g>
    </g>
  </svg>
)
export default SvgComponent
